`(function(){`
_ = if not window? and module? then require('underscore') else window._

class DateTimeFormatter
	TOKEN: /d{1,4}|M{1,4}|yy(?:yy)?|([HhmsTt])\1?|[LloSZ]|\"[^\"]*\"|\'[^']*\'/g
	TIMEZONE: /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[\-+]\d{4})?)\b/g
	TIMEZONE_CLIP: /[^\-+\dA-Z]/g

	MASKS:
		default: "ddd MMM dd yyyy HH:mm:ss"
		isoTime: "HH:mm:ss"
		isoDateTime: "yyyy-MM-dd'T'HH:mm:ss.lo"

	strings:
		days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
		daysLong: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
		months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
		monthsLong: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

	pad: (val, len = 2, pad = "0") ->
		val = String(val)
		while val.length < len
			val = pad + val
		return val

	format: (date, mask) ->
		mask = @MASKS[mask] ? mask ? @MASKS.default

		utc = mask.slice(0, 4) == "UTC:"
		mask = mask.slice(4) if utc

		pre = if utc then "getUTC" else "get"

		d = date[pre + "Date"]()
		D = date[pre + "Day"]()
		M = date[pre + "Month"]()
		y = date[pre + "FullYear"]()
		H = date[pre + "Hours"]()
		m = date[pre + "Minutes"]()
		s = date[pre + "Seconds"]()
		L = date[pre + "Milliseconds"]()
		o = if utc then 0 else date.getTimezoneOffset()

		flags =
			d:    d
			dd:   @pad(d)
			ddd:  @strings.days[D]
			dddd: @strings.daysLong[D]
			M:    M + 1
			MM:   @pad(M + 1)
			MMM:  @strings.months[M]
			MMMM: @strings.monthsLong[M]
			yy:   String(y).slice(2)
			yyyy: y
			h:    H % 12 || 12
			hh:   @pad(H % 12 || 12)
			H:    H
			HH:   @pad(H)
			m:    m
			mm:   @pad(m)
			s:    s
			ss:   @pad(s)
			l:    @pad(L, 3)
			L:    @pad(if L > 99 then Math.round(L / 10) else L)
			t:    if H < 12 then "a" else "p"
			tt:   if H < 12 then "am" else "pm"
			T:    if H < 12 then "A" else "P"
			TT:   if H < 12 then "AM" else "PM"
			Z:    if utc then "UTC" else (String(date).match(@TIMEZONE) || [""]).pop().replace(@TIMEZONE_CLIP, "")
			o:    (if o > 0 then "-" else "+") + @pad(Math.floor(Math.abs(o) / 60.0) * 100 + Math.abs(o) % 60, 4)
			S:    ["th", "st", "nd", "rd"][if d % 10 > 3 then 0 else (d % 100 - d % 10 != 10) * d % 10]

		return mask.replace @TOKEN, (match) ->
			if match of flags then flags[match] else match.slice(1, match.length - 1)

class _DateTime
	formatter: new DateTimeFormatter()

	constructor: (value, format) ->
		@date =
			if not value?
				new Date()
			else if _.isDate value
				value
			else if _.isArray value
				_DateTime.fromArray value
			else if format?
				_DateTime.fromFormat value, format
			else
				_DateTime.parse value

	clone: -> new _DateTime(new Date(@date))

	setHMS: (h, m, s, ms) ->
		if h instanceof _DateTime or _.isDate h
			ms = h.getMilliseconds()
			s = h.getSeconds()
			m = h.getMinutes()
			h = h.getHours()

		@setHours h
		@setMinutes m
		@setSeconds s
		@setMilliseconds ms if ms?

		return this

	setYMD: (y, m, d) ->
		if y instanceof _DateTime or _.isDate y
			d = y.getDate()
			m = y.getMonth()
			y = y.getFullYear()

		@setFullYear y
		@setMonth m
		@setDate d

		return this

	combine: (time) ->
		@clone().setHMS(time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds())

	format: (mask) -> @formatter.format(this, mask)

	@parse: (value) ->
		numericKeys = [1, 4, 5, 6, 7, 10, 11]

		struct = /^(\d{4}|[+\-]\d{6})(?:-(\d{2})(?:-(\d{2}))?)?(?:T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/.exec(value)

		if struct
			for k in numericKeys
				struct[k] = (+struct[k]) or 0

			# allow undefined days and months
			struct[2] = (+struct[2] or 1) - 1
			struct[3] = +struct[3] or 1

			if struct[8]? or struct[9]?
				minutesOffset = 0

				if struct[8] != 'Z' and struct[9]?
					minutesOffset = struct[10] * 60 + struct[11]

					if struct[9] == '+'
						minutesOffset = 0 - minutesOffset

				return new Date(Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]))

			return new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7])

		return new Date(value)

	@parseTime: (str) ->
		date = new this()

		return date if str.toLowerCase() == 'now'

		bits = /(\d{1,2})(?::(\d{1,2})(?::(\d{1,4})(?:\.(\d{3}))?)?)?(?:\s*([ap])\.?m?\.?)?$/i.exec(str)

		h = parseInt(bits[1] ? 0, 10)
		m = parseInt(bits[2] ? 0, 10)
		s = parseInt(bits[3] ? 0, 10)
		ms = parseInt(bits[4] ? 0, 10)

		if bits[5]
			h = h % 12
			h += 12 if bits[5].toLowerCase() == 'p'
		else if bits[1].length == 1
			# hour is not in 24-hour format, so guess
			h += 12 if h < 6

		date.setHMS h % 24, m % 60, s % 60, ms

		return date

proxyMethod = (method) -> _DateTime::[method] = -> Date::[method].apply @date, arguments

for property in "Date Time FullYear Month Day Hours Minutes Seconds Milliseconds".split " "
	proxyMethod "get#{property}"
	proxyMethod "set#{property}"
	proxyMethod "getUTC#{property}"
	proxyMethod "setUTC#{property}"

for method in "toLocaleString toLocaleDateString toLocaleTimeString toString toDateString toTimeString toUTCString toJSON getTimezoneOffset".split " "
	proxyMethod method

if not window? and module?
	module.exports = _DateTime
	_.mixin date: _DateTime
else
	@_.mixin date: _DateTime

`})();`